import { render, staticRenderFns } from "./BattleRating.vue?vue&type=template&id=36bb19df&scoped=true&lang=pug&"
import script from "./BattleRating.vue?vue&type=script&lang=js&"
export * from "./BattleRating.vue?vue&type=script&lang=js&"
import style0 from "./BattleRating.vue?vue&type=style&index=0&id=36bb19df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bb19df",
  null
  
)

export default component.exports